import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { FilePreview } from '../../File'
import { FloatingTooltipContentText } from '../../Floating'
import { useScrollSliderContext } from '../../ScrollSlider'
import { DocFlowFileOverlay } from '../DocFlowFileOverlay'

import { getFileType } from './DocFlowFile.utils'

import * as styles from './DocFlowFile.module.css'

function DocFlowFile({
  disabled,
  done,
  file,
  isActive,
  isSkeleton,
  process,
  onSelectFile,
}) {
  const { t } = useTranslation()

  const { handleClickSlide } = useScrollSliderContext()

  const fileRef = useRef(null)

  function handleClick(id) {
    handleClickSlide(fileRef.current)

    onSelectFile(id)
  }

  useEffect(() => {
    if (!isSkeleton && isActive) {
      handleClick(file.id)
    }
  }, [])

  return (
    <FilePreview
      Overlay={DocFlowFileOverlay}
      additionalInfo={getFileType(file, t)}
      className={styles.file}
      file={file}
      fileRef={fileRef}
      isSkeleton={isSkeleton}
      overlayProps={{ disabled, done, isActive, process }}
      tooltip={
        <FloatingTooltipContentText
          additionalText={
            disabled
              ? null
              : t('DocumentStapling.SplittingFileClickTooltipTextKey')
          }
          text={
            disabled
              ? t('DocumentStapling.SplittingDisabledFileClickTooltipTextKey')
              : file.name
          }
        />
      }
      tooltipContentStyles={{ visibility: isActive ? 'hidden' : 'visible' }}
      onClick={handleClick}
    />
  )
}

export default DocFlowFile
